import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import cl from "classnames";
import classes from "./styles.module.scss";
import ErrorPage from "venuescanner-js/react/components/ErrorPage";
import Form from "venuescanner-js/react/components/Form/Form";
import Password from "venuescanner-js/react/components/Form/Fields/Password/FormInput";
import Input from "venuescanner-js/react/components/Form/Fields/Input/FormInput";
import Row from "venuescanner-js/react/components/Form/Row";
import { loginValidation } from "venuescanner-js/validation/profile";
import Submit from "venuescanner-js/react/components/Form/button/Submit";
import LinkButton from "venuescanner-js/react/components/Buttons/LinkButton";
import Loading from "venuescanner-js/react/components/Loading";
import Confirmation from "venuescanner-js/react/components/Form/Notifications/Confirmation";
// import ErrorMessage from 'venuescanner-js/react/components/Form/Notifications/ErrorMessage'
import TemporaryWarning, {
  TemporaryWarningTrigger,
} from "venuescanner-js/react/components/Form/Notifications/TemporaryWarning";
import ForgotPassword from "./ForgotPassword";
import { authService } from "venuescanner-js/services/auth";
import CustomEvents, { Events } from "venuescanner-js/services/windowEvents";
import { signIn } from "venuescanner-js/services/auth/post";
import { reportError } from "venuescanner-js/react/services/errorService";

const hasLoggedIn = () => {
  CustomEvents[Events.loggedIn](authService.user); // triggers logged in events
};

const emptyData = {
  email: "",
  password: "",
};
const Login = ({ sent, showRegister }) => {
  const formContainer = useRef(null);
  const [updating, setUpdating] = useState(false);
  const [loggedIn, setLoggedIn] = useState(false);
  const [failedMessage, setFailedMessage] = useState(null);
  const [invalidEmitter] = useState(new TemporaryWarningTrigger());
  // const [passwordChanged, setPasswordChanged] = useState(false)

  const handleLoginSubmit = (values, { resetForm }) => {
    const { password, email } = values;
    setUpdating(true);
    signIn({
      password,
      email,
    }).then(({ data, status, errors }) => {
      // setPasswordChanged(false)
      setUpdating(false);
      if (!status) {
        // failed to update
        const errorMessage = errors.length
          ? errors[0].message
          : "Unable to Sign in with the given email / password";
        setFailedMessage(errorMessage);
        invalidEmitter.show();
      } else {
        resetForm({});
        setLoggedIn(true);
        hasLoggedIn();
        if (sent) sent(data);
      }
    });
  };
  return (
    <div ref={formContainer} className={classes.login}>
      <Form
        initialValues={emptyData}
        validation={loginValidation}
        handleSubmit={handleLoginSubmit}
        handleChange={() => {}}
      >
        <div
          className={cl({ [classes.completed]: loggedIn }, classes.login__form)}
        >
          <Row>
            <Input label="Email" name="email" type="email" />
          </Row>
          <Row>
            <Password label="Password" name="password" />
          </Row>
          <div className={classes["cta-area"]}>
            <TemporaryWarning
              message={failedMessage}
              eventEmitter={invalidEmitter}
              closeButton={true}
              duration={20000}
            />
            {updating ? (
              <Loading>Logging in...</Loading>
            ) : (
              <Submit visible={!loggedIn}>Sign in</Submit>
            )}
          </div>
        </div>
        <div
          className={cl(
            { [classes.completed]: loggedIn },
            classes.login__confirmation
          )}
        >
          <Confirmation>You are now signed in</Confirmation>
        </div>
        <div className={classes.login__addendum}>
          <div>
            <ForgotPassword>Request password reset</ForgotPassword>
          </div>
          <div>
            Don&apos;t have an account?{" "}
            <LinkButton onClick={showRegister}>Join now</LinkButton>
          </div>
          <div>
            By signing in you agree with our
            <br />
            <a href="/terms-and-conditions" target="_blank">
              Terms &amp; conditions and Privacy statement
            </a>
          </div>
        </div>
      </Form>
    </div>
  );
};

Login.propTypes = {
  sent: PropTypes.func,
  showRegister: PropTypes.func,
};

class ErrorBoundary extends React.Component {
  state = {
    error: null,
    errorInfo: null,
  };

  componentDidCatch(error, errorInfo) {
    this.setState({ error, errorInfo });
    reportError("SignIn - Login", error, errorInfo);
  }

  render() {
    const { state, props } = this;
    if (state.error) {
      return <ErrorPage />;
    }
    return <Login {...props} />;
  }
}
export default ErrorBoundary;
